import { useState, useEffect } from "react";
import axios from "axios";

const DAYS = [
  { id: 1, short: "Пн", full: "Понедельник" },
  { id: 2, short: "Вт", full: "Вторник" },
  { id: 3, short: "Ср", full: "Среда" },
  { id: 4, short: "Чт", full: "Четверг" },
  { id: 5, short: "Пт", full: "Пятница" },
  { id: 6, short: "Сб", full: "Суббота" },
  { id: 7, short: "Вс", full: "Воскресенье" },
];

function ScheduleRow({ emp, onSave }) {
  const [days, setDays] = useState(emp.work_days || [1,2,3,4,5]);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const toggle = (day) => {
    setDays(prev => prev.includes(day) ? prev.filter(d => d !== day) : [...prev, day].sort());
    setSaved(false);
  };

  const save = async () => {
    setSaving(true);
    try {
      await axios.patch(`/api/schedule/${emp.bitrix_id}`, { work_days: days });
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
      onSave();
    } finally {
      setSaving(false);
    }
  };

  const hasChanges = JSON.stringify(days.sort()) !== JSON.stringify((emp.work_days || [1,2,3,4,5]).sort());

  return (
    <tr style={{ borderBottom: "0.5px solid rgba(255,255,255,0.04)" }}>
      <td style={{ padding: "14px 16px" }}>
        <div style={{ fontSize: 14, fontWeight: 500, color: "#fff" }}>{emp.name}</div>
        {emp.position && <div style={{ fontSize: 12, color: "#8892a4", marginTop: 2 }}>{emp.position}</div>}
      </td>
      <td style={{ padding: "14px 16px" }}>
        <div style={{ display: "flex", gap: 6 }}>
          {DAYS.map(d => {
            const isWork = days.includes(d.id);
            const isWeekend = d.id >= 6;
            return (
              <button key={d.id} onClick={() => toggle(d.id)} title={d.full} style={{
                width: 36, height: 36, borderRadius: 6,
                border: "0.5px solid",
                borderColor: isWork
                  ? isWeekend ? "rgba(201,168,76,0.4)" : "rgba(0,210,180,0.4)"
                  : "rgba(255,255,255,0.08)",
                background: isWork
                  ? isWeekend ? "rgba(201,168,76,0.15)" : "rgba(0,210,180,0.15)"
                  : "rgba(255,255,255,0.03)",
                color: isWork
                  ? isWeekend ? "#c9a84c" : "#00d2b4"
                  : "#707777",
                fontSize: 11, fontWeight: 600, cursor: "pointer",
                transition: "all 0.15s",
              }}>
                {d.short}
              </button>
            );
          })}
        </div>
      </td>
      <td style={{ padding: "14px 16px" }}>
        <div style={{ fontSize: 12, color: "#8892a4" }}>
          {days.length} раб. / {7 - days.length} вых.
        </div>
      </td>
      <td style={{ padding: "14px 16px" }}>
        {saved ? (
          <span style={{ fontSize: 12, color: "#00d2b4" }}>✓ Сохранено</span>
        ) : hasChanges ? (
          <button onClick={save} disabled={saving} style={{
            padding: "6px 16px", background: "linear-gradient(90deg, #00d2b4, #cbfffc)",
            border: "none", borderRadius: 6, color: "#011d1c", fontSize: 12,
            fontWeight: 600, cursor: "pointer", opacity: saving ? 0.7 : 1,
          }}>
            {saving ? "..." : "Сохранить"}
          </button>
        ) : null}
      </td>
    </tr>
  );
}

export default function Schedule() {
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/api/schedule/");
      setSchedules(res.data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <div style={{ fontFamily: "Inter, sans-serif", color: "#fff" }}>
      <div style={{ marginBottom: 28 }}>
        <div style={{ fontSize: 24, fontWeight: 600, color: "#fff", marginBottom: 4 }}>Расписание</div>
        <div style={{ fontSize: 14, color: "#8892a4" }}>
          Рабочие дни сотрудников — агент не проверяет отчёты в выходные дни
        </div>
      </div>

      <div style={{ background: "rgba(0,210,180,0.05)", border: "0.5px solid rgba(0,210,180,0.2)", borderRadius: 8, padding: "12px 16px", marginBottom: 24, fontSize: 13, color: "#bbc7c6", display: "flex", gap: 24 }}>
        <span><span style={{ display: "inline-block", width: 12, height: 12, background: "rgba(0,210,180,0.3)", borderRadius: 2, marginRight: 6, verticalAlign: "middle" }}></span>Рабочий день</span>
        <span><span style={{ display: "inline-block", width: 12, height: 12, background: "rgba(201,168,76,0.3)", borderRadius: 2, marginRight: 6, verticalAlign: "middle" }}></span>Рабочий (выходная зона)</span>
        <span><span style={{ display: "inline-block", width: 12, height: 12, background: "rgba(255,255,255,0.05)", borderRadius: 2, marginRight: 6, verticalAlign: "middle" }}></span>Выходной</span>
      </div>

      {loading ? (
        <div style={{ color: "#8892a4", padding: 40, textAlign: "center" }}>Загрузка...</div>
      ) : (
        <div style={{ background: "#011d1c", border: "0.5px solid rgba(0,210,180,0.2)", borderRadius: 12, overflow: "hidden" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ borderBottom: "0.5px solid rgba(0,210,180,0.15)" }}>
                {["Сотрудник", "Рабочие дни", "Итого", ""].map(h => (
                  <th key={h} style={{ padding: "12px 16px", fontSize: 11, fontWeight: 600, color: "#8892a4", textAlign: "left", letterSpacing: "0.08em", textTransform: "uppercase" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {schedules.map(emp => (
                <ScheduleRow key={emp.bitrix_id} emp={emp} onSave={load} />
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
